import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import {AdminCoursesList} from "./AdminCoursesList/AdminCoursesList";
import {AdminCoursePage} from "./AdminCoursePage";
import {AdminCourseLandingPage} from "./AdminCourseLandingPage/AdminCourseLandingPage";
import {AdminLessonLandingPage} from "../Lessons/AdminLessonLandingPage";
import {AdminLessonPage} from "../Lessons/AdminLessonPage";
import {AdminQuizPage} from "../Quizzes/AdminQuizPage";

const useStyles = makeStyles()((theme) => ({
	adminCoursesPage: {

	}
}));

export const AdminCoursesPage: FC = () => {
	const {classes} = useStyles();

	return (
		<Box className={classes.adminCoursesPage}>
			<Routes>
				<Route index element={<AdminCoursesList />}/>
				<Route path="create" element={<AdminCoursePage />} />
				<Route path="create-new" element={<AdminCoursePage newContent />} />
				<Route path=":id/*" element={<AdminCourseLandingPage />} />
				<Route path=":id/edit" element={<AdminCoursePage />} />
				<Route path=":id/edit-new" element={<AdminCoursePage newContent />} />
				<Route path=":id/lessons/:lessonId" element={<AdminLessonLandingPage />} />
				<Route path=":id/lessons/:lessonId/edit" element={<AdminLessonPage />} />
				<Route path=":id/lessons/:lessonId/edit-new" element={<AdminLessonPage newContent />} />
				<Route path=":id/quizzes/:quizId" element={<AdminQuizPage />} />
				<Route path=":id/quizzes/:quizId/edit" element={<AdminQuizPage />} />
			</Routes>
		</Box>
	);
}